import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  CalendarIcon,
  DocumentTextIcon, 
  ChatBubbleLeftRightIcon,
  FolderIcon, 
  DocumentDuplicateIcon,
  CalendarDaysIcon,
  PlusIcon
} from '@heroicons/react/24/outline';

const MobileNavBar = () => {
  const location = useLocation();

  // Helper to determine if a path is active
  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="md:hidden fixed bottom-4 left-4 right-4 z-50 safe-padding-bottom">
      <div className="relative flex flex-col items-end space-y-3">
        {/* Create Workspace Button */}
        <Link 
          to="/workspaces/new" 
          className="flex items-center justify-center rounded-full bg-[#1a1a1a] p-3 shadow-lg hover:bg-[#252525] border border-[#333]"
          aria-label="Create Workspace"
        >
          <PlusIcon className="h-6 w-6 text-white" />
        </Link>
        
        {/* Main Navigation */}
        <nav className="relative flex items-center justify-between bg-black border border-[#333333] rounded-full px-4 py-2 shadow-2xl w-full">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex flex-col items-center p-1"
            aria-label="Home"
          >
            <img
              src="/logo.svg"
              alt="Blossom Logo"
              className="h-6 w-6"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3QgeD0iNCIgeT0iNCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiAvPjxwYXRoIGQ9Ik0xMiA0IFYyMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiAvPjxwYXRoIGQ9Ik00IDEyIEgyMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiAvPjwvc3ZnPg==';
              }}
            />
          </Link>
          
          {/* Dashboard */}
          <Link 
            to="/" 
            className={`flex flex-col items-center p-1 ${isActive('/') && !location.pathname.includes('personal') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Dashboard"
          >
            <HomeIcon className="h-6 w-6" />
          </Link>
          
          {/* Calendar */}
          <Link 
            to="/calendar" 
            className={`flex flex-col items-center p-1 ${isActive('/calendar') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Calendar"
          >
            <CalendarIcon className="h-6 w-6" />
          </Link>
          
          {/* Documents */}
          <Link 
            to="/documents" 
            className={`flex flex-col items-center p-1 ${isActive('/documents') && !location.pathname.includes('personal') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Documents"
          >
            <DocumentTextIcon className="h-6 w-6" />
          </Link>
          
          {/* Chat */}
          <Link 
            to="/chat" 
            className={`flex flex-col items-center p-1 ${isActive('/chat') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Chat"
          >
            <ChatBubbleLeftRightIcon className="h-6 w-6" />
          </Link>
          
          {/* Workspaces */}
          <Link 
            to="/workspaces" 
            className={`flex flex-col items-center p-1 ${isActive('/workspaces') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Workspaces"
          >
            <FolderIcon className="h-6 w-6" />
          </Link>
          
          {/* Divider */}
          <div className="w-px h-6 bg-[#333333]"></div>
          
          {/* Dinosaur icon */}
          <div className="flex flex-col items-center p-1 text-gray-400">
            <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3C7.58 3 4 6.58 4 11V21H15V11C15 7.69 18.14 5.15 22 5.01V5C22 3.89 21.1 3 20 3H12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M19 5L16 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 16H7.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 14L20 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          {/* Personal Calendar */}
          <Link 
            to="/personal/calendar" 
            className={`flex flex-col items-center p-1 ${isActive('/personal/calendar') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Personal Calendar"
          >
            <CalendarDaysIcon className="h-6 w-6" />
          </Link>
          
          {/* Personal Documents */}
          <Link 
            to="/personal/documents" 
            className={`flex flex-col items-center p-1 ${isActive('/personal/documents') ? 'text-white' : 'text-gray-400'}`}
            aria-label="Personal Documents"
          >
            <DocumentDuplicateIcon className="h-6 w-6" />
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default MobileNavBar; 